import { Partners } from 'utils/constants';
import { PRODUCT } from 'utils/segment/constants';

export function getGroup(partnerGroupName, partnerId) {
    const prefixWithUnderscore = `${partnerId}_`;
    if (partnerGroupName.startsWith(prefixWithUnderscore)) {
        return partnerGroupName.slice(prefixWithUnderscore.length);
    }
    return '';
}

export function getProduct(partnerId: string) {
    return partnerId === Partners.HERO_VIDA
        ? PRODUCT.AUTO
        : PRODUCT.ELECTRONICS;
}
